import { AxiosRequestConfig } from 'axios'
import { CallEffect, PutEffect, SelectEffect } from 'redux-saga/effects'

import { ApiResponse, ErrorData } from '../../interfaces'
import { ISendToLoginFallback } from '../sendTo'

export interface IError extends ErrorData {
  status: number
}

export interface IClientData {
  name: string
  document: string
  phoneNumber: string
}

export interface IFetchClientDataPayload {
  userId: string
  sessionToken: string
  middleware?: AxiosRequestConfig
}

export type ClientDataGeneratorYield =
  | SelectEffect
  | CallEffect<ApiResponse<IClientData | ErrorData>>
  | PutEffect<IFetchClientDataSuccess | IFetchClientDataFail | ISendToLoginFallback>

export type ClientDataGeneratorReturn = IClientData | ApiResponse<string | IError>

export const FETCH_CLIENT_DATA = 'FETCH_CLIENT_DATA'
export const FETCH_CLIENT_DATA_SUCCESS = 'FETCH_CLIENT_DATA_SUCCESS'
export const FETCH_CLIENT_DATA_FAIL = 'FETCH_CLIENT_DATA_FAIL'

export const UPDATE_CLIENT_DATA = 'UPDATE_CLIENT_DATA'

export interface IFetchClientData {
  type: typeof FETCH_CLIENT_DATA
  payload: IFetchClientDataPayload
}

export interface IFetchClientDataSuccess {
  type: typeof FETCH_CLIENT_DATA_SUCCESS
  payload: IClientData
}

export interface IFetchClientDataFail {
  type: typeof FETCH_CLIENT_DATA_FAIL
  payload: IError
}

export interface IUpdateClientData {
  type: typeof UPDATE_CLIENT_DATA
  payload: IClientData
}

export type ClientDataDispatchTypes =
  | IFetchClientData
  | IFetchClientDataSuccess
  | IFetchClientDataFail
  | IUpdateClientData
